import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'mt-body-small',
    templateUrl: './body-small.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BodySmallComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
